/*
 * @Author: chenxuelai 2251702447@qq.com
 * @Date: 2023-07-05 09:26:23
 * @LastEditors: chenxuelai 2251702447@qq.com
 * @LastEditTime: 2023-10-18 17:41:10
 * @FilePath: /vue_huaqiang/src/api/order-library.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from "@/utils/oms-request";
import download from "@/utils/oms-download";

export const searchOrderLibrary = (data: any) =>
  request({
    url: `/order-library/search`,
    method: "get",
    params: data,
  });
export const searchOrderLibraryModels = (data: { ids: any }) =>
  request({
    url: `/order-library/models`,
    method: "post",
    data: data,
  });
export const searchorderLibraryInfos = (data: { ids: any }) =>
  request({
    url: `/order-library/infos`,
    method: "post",
    data: data,
  });

export const getOrderLibraryTableHeader = () =>
  request({
    url: `/order-library/table-fields`,
    method: "GET",
  });
 // 查看备注
//  /order-library/id/extends
export const getOrderListRemark = (id) =>
  request({
    url: `/order-library/${id}/extends`,
    method: "get",
  });
  // /quote-library/{id}/extend-info
  //报价库查看备注
export const getBaoJiaListRemark = (id) =>
  request({
    url: `/quote-library/${id}/extend-info`,
    method: "get",
  });

  // /order-library/{id}/update-product-number
  // 下单库异常文件上传
export const updateProductNumbeXia = (id,data) =>
  request({
    url: `/order-library/${id}/update-product-number`,
    method: "post",
    data
  });
  // /order-library/history-price
  // 查看历史报价
export const getHistoryPrice = (params) =>
  request({
    url: `/order-library/history-price`,
    method: "get",
    params
  });
  // /order-library/history-price/download
  // 下载历史报价
export const downloadHistoryPrice = (params) =>
  download({
    responseType: "blob",
    url: `/order-library/history-price/download`,
    method: "get",
    params
  });

  // /order-library/download
export const downloadOrderLibrary = (params) =>
  download({
    responseType: "blob",
    url: `/order-library/download`,
    method: "get",
    params
  });
  // /quote-library/download
export const downloadQuoteLibrary = (params) =>
  download({
    responseType: "blob",
    url: `/quote-library/download`,
    method: "get",
    params
  });

export const existedProduct = (params: any) =>
  request({
      url: `/order-library/existed-no-matched-product`,
      method: "get",
      params
  });

  // /order-library/editable-info 查询可编辑的字段
  export const getEditableInfo  = (params: any) =>
  request({
      url: `/order-library/editable-info`,
      method: "get",
      params
  });
  // /order-library/upload-record 删除最新的上传记录
  export const deleteUploadRecord  = (params: any) =>
  request({
      url: `/order-library/upload-record`,
      method: "delete",
      params
  });
  // /order-library/editable-info/{id} //更改可编辑字段
  export const putEditableInfo  = (id,data: any) =>
  request({
      url: `/order-library/editable-info/${id}`,
      method: "put",
      data
  });
  // /order-library/extend-info 更改额外信息
  export const putExtendInfo  = (params,data: any) =>
  request({
      url: `/order-library/extend-info`,
      method: "put",
      params,
      data
  });

  // /order-library/copy get 查询可复制的下单库记录
  export const getYesCopy  = (params: any) =>
  request({
      url: `/order-library/copy`,
      method: "get",
      params
  });
  // /order-library/copy post 复制下单库
  export const postYesCopy  = (data: any) =>
  request({
      url: `/order-library/copy`,
      method: "post",
      data
  });